import { CheckIcon } from '@app/app/_icons/CheckIcon';
import { ReactNode } from 'react';
import { XFilledIcon } from '@app/app/_icons/XFilledIcon';

interface Props {
    children: ReactNode;
    agreed?: boolean;
}

export function ChecklistItem({ children, agreed = true }: Props) {
    return (
        <div className="inline-flex items-start gap-3">
            {agreed && (
                <span className="inline-flex h-6 items-center">
                    <CheckIcon className="size-4 shrink-0 text-primary-400" />
                </span>
            )}

            {!agreed && (
                <span className="inline-flex h-6 items-center">
                    <XFilledIcon className="size-4 shrink-0 text-red-400" />
                </span>
            )}

            <span>{children}</span>
        </div>
    );
}
